import { AxiosInstance } from 'axios'
import { Dayjs } from 'dayjs'
import { CoordinateType } from '@/api/types/general/GeneralType'
import { WeatherType } from '@/utilities/weather/types/WeatherType'
import { OpenWeatherHistoryResponseType } from '@/utilities/weather/services/openWeatherApi/types/OpenWeatherResponseType'
import OpenWeatherIcon from '@/utilities/weather/services/openWeatherApi/OpenWeatherIcon'
import AbstractWeatherService from '@/utilities/weather/services/abstracts/AbstractWeatherService'

export default class HistoryWeatherProvider extends AbstractWeatherService {
  private readonly baseUrl: string

  constructor(apiKey: string, httpClient: AxiosInstance, baseUrl: string) {
    super(apiKey, httpClient)

    this.baseUrl = baseUrl
  }

  async getInfo({ lat, lng }: CoordinateType, date: Dayjs): Promise<WeatherType> {
    const url = `${this.baseUrl}/onecall/timemachine`

    const params = new URLSearchParams({
      appid: this.apiKey,
      lat: String(lat),
      lon: String(lng),
      dt: String(date.unix()),
      units: 'metric',
    })

    const { data } = await this.httpClient.get<OpenWeatherHistoryResponseType>(`${url}?${params.toString()}`)

    const weather = data?.current?.weather[0] as OpenWeatherHistoryResponseType['current']['weather'][0] | undefined

    if (!weather) {
      throw new Error('Invalid response')
    }

    return {
      title: weather.main,
      description: weather.description,
      icon: new OpenWeatherIcon(weather.icon).getIcon(),
      temp: data.current.temp,
    }
  }
}
